import * as React from 'react';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Container, Grid, Typography, TextField,
 Button, MenuItem, Select, InputLabel, Snackbar, Alert, CircularProgress } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import StepProgress from './StepProgress';


export default function FormComponent() {
 // const [maritalStatus, setMaritalStatus] = React.useState("");
 // const [occupation, setOccupation] = React.useState("");



 // State variables for form fields
 const [formData, setFormData] = useState({
   First_Name: "",
   Last_Name: "",
   DOB: "",
   Mobile_Number: "",
   City: "",
   District: "",
   State: "",
   Pincode: "",
   ID_Proof_Type: "", // Stores either 'Aadhar' or 'License'
   ID_Proof_Number: "",
   Pan_Card:"",
   Pan_Number:  "",
   User_Type: "",
   Member_ID: "",
   Email: "",
   Family_Details: "",
   Occupation: "",
   Address: "",
   Marital_Status: "",
   Star: "",
   Raasi: "",
   Kootram: "",
   Kuladeivam: "",
  Payment_Status: ""
 });


 const isPaymentPending = formData?.Payment_Status === "Unpaid";
 const [loading, setLoading] = useState(true); 
  const [errors, setErrors] = useState({});
      const validateForm = () => {
       let newErrors = {};
    
       if (!formData.Occupation.trim()) {
         newErrors.Occupation = " "; 
       }
       if (!formData.Address || formData.Address.trim() === "") {
         newErrors.Address = " ";
       }
       if (!formData.Email.trim()) {
         newErrors.Email = " ";
       } else if (
         !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.Email)
       ) {
         newErrors.Email = "Enter a valid email address";
       }
       if (!formData.Family_Details.trim()) {
         newErrors.Family_Details = " "; 
       }
       if (!formData.Star) {
         newErrors.Star = " "; 
       }
       if (!formData.Raasi.trim()) {
         newErrors.Raasi = " "; 
       }
       if (!formData.Kootram.trim()) {
         newErrors.Kootram = " "; 
       }
       if (!formData.Kuladeivam.trim()) {
         newErrors.Kuladeivam = " "; 
       }
      
       if (formData.Pan_NumberPan_Number && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.Pan_Number)) {
         newErrors.Pan_Number = "Enter a valid PAN Number (Eg: ABCDE1234F)";
       }


     
       setErrors(newErrors);
       return Object.keys(newErrors).length === 0;
 };




 const [formData2, setFormData2] = useState({
   firstName: "",
   lastName: "",
   mobile: "",
   dob: "",
   city: "",
   district: "",
   state: "",
   pincode: "",
   identityProofType: "",
   identityProofNumber: "",
   panCard: "",
   panCardNumber: "",
   email: "",
   occupation: "",
   address: "",
   familyDetails: "",
   maritalStatus: "",
   star: "",
   raasi: "",
   kootram: "",
   kuladeivam: ""
 });






 useEffect(() => {
   setFormData2({
     firstName: formData.First_Name,
     lastName: formData.Last_Name,
     mobile: formData.Mobile_Number,
     dob: formData.DOB,
     city: formData.City,
     district: formData.District,
     state: formData.State,
     pincode: formData.Pincode,
     identityProofType: formData.ID_Proof_Type,
     identityProofNumber: formData.ID_Proof_Number,
     panCard: formData.Pan_Card,
     panCardNumber: formData.Pan_Number,
     email: formData.Email,
     occupation: formData.Occupation,
     address: formData.Address,
     familyDetails: formData.Family_Details,
     maritalStatus: formData.Marital_Status,
     star: formData.Star,
     raasi: formData.Raasi,
     kootram: formData.Kootram,
     kuladeivam: formData.Kuladeivam
   });
 }, [formData]);








 const handleSubmit = async (e) => {
   e.preventDefault();
   if (!validateForm()) return;


   const formattedDob = new Date(formData.DOB).toLocaleDateString('en-CA');


   setFormData2({
     firstName: formData.First_Name,
     lastName: formData.Last_Name,
     mobile: formData.Mobile_Number,
     dob: formattedDob,
     city: formData.City,
     district: formData.District,
     state: formData.State,
     pincode: formData.Pincode,
     identityProofType: formData.ID_Proof_Type,
     identityProofNumber: formData.ID_Proof_Number,
     panCard: formData.Pan_Card,
     panCardNumber: formData.Pan_Number,
     email: formData.Email,
     occupation: formData.Occupation,
     address: formData.Address,
     familyDetails: formData.Family_Details,
     maritalStatus: formData.Marital_Status,
     star: formData.Star,
     raasi: formData.Raasi,
     kootram: formData.Kootram,
     kuladeivam: formData.Kuladeivam,
 });


   const requestBody = {
     method: "put",  // Include this field
     ...formData2,  // Spread form data
 };


   try {
       // eslint-disable-next-line
       const response = await fetch(
           "https://script.google.com/macros/s/AKfycbzO0HtLQInQTBfvP8qv_A5sOSIqcKylyQVKFm7pTEzOIEX6IgCv1hJddRZJuntDsgXqiw/exec",
           {
               method: "POST",
               mode: "no-cors", // Prevents CORS issues
               headers: {
                   "Content-Type": "application/json",
               },
               body: JSON.stringify({ method: "put", ...formData2 }),
           }
       );
       console.log(formData2);
       console.log("Form sent successfully", formData);
       // Show confirmation message (if needed)
    
       setOpenSnackbar(true);


           // Clear the form after submission
           setFormData({
             ID_Proof_Type: "", // Stores either 'Aadhar' or 'License'
             ID_Proof_Number: "",
             Pan_Card:"",
             Pan_Number:  "",
             Email: "",
             Family_Details: "",
             Occupation: "",
             Address: "",
             Marital_Status: "",
             Star: "",
             Raasi: "",
             Kootram: "",
             Kuladeivam: "",
              });


         // Redirect after success
         setTimeout(() => {
             navigate("/membership");
         }, 2000);
      
   } catch (error) {
       console.error("Error sending data:", error);
       alert("Failed to send data");
   }
};
     const handleCloseSnackbar = () => {
       setOpenSnackbar(false);
     };


const [openSnackbar, setOpenSnackbar] = useState(false);
const navigate = useNavigate();




const districts = ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
 "Dindigul" , "Erode", "Kallakurichi", "Kancheepuram", "Kanyakumari", "Karur", "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal",
 "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
 "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Thiruchirappalli", "Tirunelveli", "Tirupathi",
 "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar"
];
const states = ["Tamil Nadu"];


const Stars = ["Ashwini", "Bharani","Krithikai","Rohini", "Mirgasheersham", "Thiruvaathirai" , "Punarpoosam", "Poosam",
 ,"Aayilyam", "Pooram","Uthiram","Hastham","Chithirai","Swaathi","Visaakam"
 ,"Anusham","Kettai", "Moolam","Pooraadam","Uthiraadam","Thiruvonam","Avittam",
"Chathayam/Sadayam","Poorattathi", "Uthirattathi", "Revathi","Makam" ]








  // Handles radio button changes
const handleRadioChange = (e) => {


 setFormData({ ...formData, ID_Proof_Type: e.target.value });
};


  // Handles radio button changes
  const handlestatusChange = (e) => {
   setFormData({ ...formData, Marital_Status: e.target.value });
 };


 const handlePanChange = (e) => {
   setFormData({ ...formData, Pan_Card: e.target.value, Pan_Number: e.target.value === "Yes" ? "" : formData.Pan_Number });
};




 useEffect(() => {
   // Get mobile number & user type from localStorage
   const mobile = localStorage.getItem("mobile");
   const userType = localStorage.getItem("user_type");


   if (!mobile || !userType) {
     console.error("Mobile number or user type not found in localStorage");
     return;
   }


   // Fetch API data
   axios
     .get(`https://script.google.com/macros/s/AKfycbzO0HtLQInQTBfvP8qv_A5sOSIqcKylyQVKFm7pTEzOIEX6IgCv1hJddRZJuntDsgXqiw/exec?action=myprofile&mobile=${mobile}`)
     .then((response) => {
       if (response.data.status === "success") {
         setLoading(false);
         console.log(response.data.data)
         setFormData(response.data.data); // Populate state with API data
       } else {
         console.error("API returned an error:", response.data.message);
       }
     })
     .catch((error) => {
       console.error("Error fetching data:", error);
     })
     .finally(() => {
      setLoading(false); // Set loading to false after fetch completes
    });
 }, []);






 const handleChange = (e) => {
   const { name, value } = e.target;
   setFormData((prevData) => ({
     ...prevData,
     [name]: value,
   }));
 };


 console.log("ID_ProofType:", formData.ID_Proof_Type);
 console.log("formData:", formData);


 return (
  
   <Box sx={{ backgroundColor: "#f8f9e9", py: 6, top: "150px", bottom: "150px"  }}>
     <Container>
       <StepProgress />
       <Typography variant="h5" sx={{ fontWeight: "400", color: "#E52029", mb: 2, fontSize: "20px", textAlign: "center" }}>
         Kindly fill the details and pay 2000 to get member ID
       </Typography>
       {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress />
          </Box>
        ) : (
       <Grid item xs={12} md={6}>
         <Box
           component="form"
           sx={{
             backgroundColor: "#f8f9e9",
             padding: 4,
             borderRadius: "8px",
             borderColors: "#CEC35E",
             boxShadow: 3,
           }}
         >
           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
             <TextField
               fullWidth
               disabled
               label="First Name"
               placeholder="First Name"
               name="First_Name"
               value={formData.First_Name}
               onChange={handleChange}
               inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
               sx={{ mb: 2 }}
               required
             />
             <TextField
               fullWidth
               required
               disabled
               label="Last Name"
               placeholder="Last Name"
               name="Last_Name"
               value={formData.Last_Name}
               onChange={handleChange}
               inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
               sx={{ mb: 2 }}
             />
             <TextField
               fullWidth
               required
               disabled
               label="Date of Birth"
               type="date"
               name="DOB"
               value={formData.DOB ? new Date(formData.DOB).toISOString().split("T")[0] : ""}
               onChange={handleChange}
               InputLabelProps={{ shrink: true }}
               sx={{ mb: 2 }}
             />
             <TextField
               fullWidth
               required
               disabled
               label="Mobile Number"
               placeholder="Your Mobile Number"
               type="tel"
               name="Mobile_Number"
               value={formData.Mobile_Number}
               onChange={handleChange}
               inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
               sx={{ mb: 2 }}
             />
             <TextField
               fullWidth
               required
               disabled
               label="City"
               placeholder="City"
               name="City"
               value={formData.City}
               onChange={handleChange}
               sx={{ my: 2 }}
               inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
             />


             <FormControl fullWidth required disabled>
             <InputLabel>District</InputLabel>
             <Select
             name="district"
             value={formData.District}
             onChange={handleChange}
             error={!!errors.District} 
               helperText={errors.District || ""}
               required
             sx={{ textAlign: "left" , my: 2 }} >
             {districts.map((district, index) => (
              <MenuItem key={index} value={district}>
               {district}
                </MenuItem>
                ))}
              </Select>
             </FormControl>


             <FormControl fullWidth  required disabled>
              <InputLabel>State</InputLabel>
              <Select name="state" value={formData.State}
              onChange={handleChange}
              error={!!errors.state} 
               helperText={errors.state|| ""}
               required
               sx={{ textAlign: "left", my: 2 }} >
               {states.map((state, index) => (
                <MenuItem key={index} value={state}>
                 {state}
                 </MenuItem>
                      ))}
                 </Select>
                  </FormControl>
             <TextField
               fullWidth
               required
               disabled
               label="Pincode"
               placeholder="Pincode"
               type="number"
               name="Pincode"
               value={formData.Pincode}
               onChange={handleChange}
               sx={{ my: 2 }}
               inputProps={{ maxLength: 10, pattern: "[0-6]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6)}
             />
           
             <TextField
               fullWidth
               disabled
               label="Member ID"
               placeholder="Member ID"
               type="text"
               name="Member_ID"
               value={formData.Member_ID}
               onChange={handleChange}
               sx={{ my: 2 }}
               inputProps={{ maxLength: 10, pattern: "[A-Za-z0-9]*" }}
               onInput={(e) => {
                 e.target.value = e.target.value
                   .replace(/[^A-Za-z0-9]/g, '')
                   .slice(0, 10);
               }}
             />
             <TextField
               fullWidth
               label="Occupation"
               placeholder="Occupation"
               type="text"
               name="Occupation"
               value={formData.Occupation}
               onChange={handleChange}
               sx={{ my: 2 }}
               error={!!errors.Occupation} 
               helperText={errors.Occupation|| ""}
               required
               inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
             />
             <TextField
              fullWidth
              label="Address"
              placeholder="Address"
              type="text"
              name="Address"
              value={formData.Address}
             onChange={handleChange}
              sx={{ my: 2 }}
              error={!!errors.Address} 
              helperText={errors.Address || ""}
              required
              inputProps={{ maxLength: 50, pattern: "[A-Za-z0-9, ]*" }}
              onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z0-9, ]/g, '')}
             />
             <TextField
               fullWidth
               label="Email ID"
               placeholder="Enter you Email ID"
               type="email"
               name="Email"
               value={formData.Email}
               onChange={handleChange}
               sx={{ my: 2 }}
               error={!!errors.Email} 
               helperText={errors.Email|| ""}
               required
               inputProps={{ maxLength: 50 }}
             />
             <TextField
               fullWidth
               label="Family Details"
               placeholder="Family Details"
               name="Family_Details"
               value={formData.Family_Details}
               onChange={handleChange}
               sx={{ my: 2 }}
               error={!!errors.Family_Details} 
               helperText={errors.Family_Details|| ""}
               required
               inputProps={{ maxLength: 70, pattern: "[A-Za-z0-9, ]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z0-9, ]/g, '')}
             />
            
             <FormControl fullWidth required>
             <InputLabel>Star</InputLabel>
             <Select
             name="Star"
             value={formData.Star}
             onChange={handleChange}
             error={!!errors.Star} 
               helperText={errors.Star || ""}
               required
             sx={{ textAlign: "left" , my: 2 }} >
             {Stars.map((Stars, index) => (
              <MenuItem key={index} value={Stars}>
               {Stars}
                </MenuItem>
                ))}
              </Select>
             </FormControl>


             <FormControl fullWidth >
               <InputLabel id="occupation-label">Raasi*</InputLabel>
               <Select
                 labelId="occupation-label"
                 name="Raasi"
                 value={formData.Raasi}
                 onChange={handleChange}
                 error={!!errors.Raasi} 
               helperText={errors.Raasi|| ""}
               required
               sx={{ textAlign: "left", my: 2 }} >
              
                 <MenuItem value="Mesham">Mesham</MenuItem>
                 <MenuItem value="Risabham">Risabham</MenuItem>
                 <MenuItem value="Mithunam">Mithunam</MenuItem>
                 <MenuItem value="Kadagam">Kadagam</MenuItem>
                 <MenuItem value="Simmam">Simmam</MenuItem>
                 <MenuItem value="Kanni">Kanni</MenuItem>
                 <MenuItem value="Thulam">Thulam</MenuItem>
                 <MenuItem value="Viruchigam">Viruchigam</MenuItem>
                 <MenuItem value="Dhanushu">Dhanushu</MenuItem>
                 <MenuItem value="Magaram">Magaram</MenuItem>
                 <MenuItem value="Kumbham">Kumbham</MenuItem>
                 <MenuItem value="Meenam">Meenam</MenuItem>
               </Select>
             </FormControl>
             <TextField
               fullWidth
               label="Kootram"
               placeholder="Kootram"
               name="Kootram"
               value={formData.Kootram}
               onChange={handleChange}
               error={!!errors.Kootram} 
               helperText={errors.Kootram|| ""}
               required
               sx={{ my: 2 }}
               inputProps={{ maxLength: 50, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
             />
             <TextField
               fullWidth
               label="Kuladeivam"
               placeholder="Kuladeivam"
               name="Kuladeivam"
               value={formData.Kuladeivam}
               onChange={handleChange}
               sx={{ my: 2 }}
               error={!!errors.Kuladeivam} 
               helperText={errors.Kuladeivam|| ""}
               required
               inputProps={{ maxLength: 100, pattern: "[A-Za-z]*" }}
               onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
             />


                {/* Marital Status */}
               <Box sx={{ backgroundColor: "#f8f9e9", padding: 2 }}>
               <Grid container spacing={2} alignItems="center">
  
            
              <Grid item xs={2}>
                  <FormLabel sx={{ whiteSpace: "nowrap" }}  > Marital Status</FormLabel>
               </Grid>


               {/* Marital Status Radio Buttons */}
               <Grid item xs={12} sm={10}>
                 <FormControl component="fieldset">
                   <RadioGroup row name="maritalStatus" value={formData.Marital_Status}
                   onChange={handlestatusChange}
                   required
                   >
                     <FormControlLabel value="Yes" control={<Radio />} label="Single" />
                     <FormControlLabel value="No" control={<Radio />} label="Married" />
                   </RadioGroup>
                 </FormControl>
               </Grid>


             </Grid>
             </Box>
             <Box sx={{ backgroundColor: "#f8f9e9", padding: 2 }}>
             <Grid container spacing={2} alignItems="center">
                 {/* ID Proof Label & Radio Buttons in One Row */}
                 <Grid item xs={2}>
                     <  FormLabel sx={{ whiteSpace: "nowrap" }}>ID Proof </FormLabel>
                   </Grid>
                   <Grid item xs={12} sm={10}>
                     <FormControl component="fieldset">
                       <RadioGroup
                         row
                         name="ID_ProofType"
                         value={formData.ID_Proof_Type}
                         onChange={handleRadioChange}
                         required
                       >
                         <FormControlLabel
                        
                           value="aadhaar"
                           control={<Radio sx={{ color: "gray" }} />}
                           label="Aadhaar"
                         />
                         <FormControlLabel
                           value="license"
                           control={<Radio sx={{ color: "grey" }} />}
                           label="License"
                         />
                         <FormControlLabel
                           value="None"
                           control={<Radio sx={{ color: "grey" }} />}
                           label="None"
                         />
                       </RadioGroup>
                     </FormControl>
                   </Grid>


                   {/* Aadhar Number Field */}
                   {formData.ID_Proof_Type === "aadhaar" && (
                     <Grid item xs={12}>
                       <TextField
                         fullWidth
                         label="Aadhaar Number"
                         type="Number"
                         name="ID_Proof_Number"
                         value={formData.ID_Proof_Number}
                         onChange={handleChange}
                         error={
                           formData.identityProofNumber && !/^\d{12}$/.test(formData.identityProofNumber)
                         }
                         helperText={
                           formData.identityProofNumber && !/^\d{12}$/.test(formData.identityProofNumber)
                             ? "Enter a valid Aadhaar Number (must be 12 digits)"
                             : ""
                         }
                         required
                         inputProps={{ maxLength: 12 }}
                         placeholder="Enter Aadhaar Number"
                         onInput={(e) =>
                           (e.target.value = e.target.value.replace(/\D/g, "").slice(0, 12))
                         }
                      
                       />
                    
                     </Grid>
                   )}


                 {/* License Number Field */}
                 {formData.ID_Proof_Type === "license" && (
                   <Grid item xs={12}>
                     <TextField
                       fullWidth
                       label="License Number"
                       type="text"
                       name="ID_Proof_Number"
                       value={formData.ID_Proof_Number}
                       placeholder="Enter License Number"
                       onChange={handleChange}
                   error={
                     formData.identityProofNumber && !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)
                   }
                   helperText={
                     formData.identityProofNumber && !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)
                       ? "Enter a valid License Number (e.g., AB1234567890123)."
                       : ""
                   }
                       inputProps={{ maxLength: 15 }}
                       required
                       onInput={(e) =>
                         (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15))
                       }
                     />
                   </Grid>
                     )}
                   </Grid>
                   </Box>
            
                       {/* PAN Requirement Selection */}
                       <Box sx={{ backgroundColor: "#f8f9e9", padding: 2 }}>
                 <Grid container spacing={4} alignItems="center">
                  
                   {/* PAN Number Label */}
                   <Grid item xs={2}>
                   <FormLabel sx={{ whiteSpace: "nowrap" }} >PAN Card</FormLabel>
                   </Grid>


                   {/* PAN Required Radio Buttons */}
                   <Grid item xs={12} sm={10}>
                     <FormControl component="fieldset">
                       <RadioGroup row name="Pan_Card" value={formData.Pan_Card}
                       onChange={handlePanChange}
                      
                       required>
                         <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                         <FormControlLabel value="No" control={<Radio />} label="No" />
                         <FormControlLabel value="Later" control={<Radio />} label="Later" />
                       </RadioGroup>
                     </FormControl>
                   </Grid>


                 </Grid>
                 <Box sx={{ backgroundColor: "#f8f9e9", mt:2}}>

                   {/* PAN Number Field (Only if "Yes" is selected) */}
                   {formData.Pan_Card === "Yes" && (
                     <Grid container spacing={2}>
                    
                       <Grid item xs={12}>
                         <TextField
                           fullWidth
                           label="PAN Number"
                           placeholder="Enter PAN Number"
                           name="Pan_Number"
                           value={formData.Pan_Number}
                           onChange={handleChange}
                           error={!!errors.Pan_Number} 
                           helperText={errors.Pan_Number|| ""}
                           required 
                           inputProps={{ maxLength: 10 }}
                           onInput={(e) =>(e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))
                           }
                               />
                             </Grid>
                           </Grid>
                         )}
                       </Box>
                       </Box>
           </div>
    
         </Box>


                  <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                   <Grid item>
                     <Button
                     type="submit"
                     variant="contained"
                     onClick={handleSubmit}
                     fullWidth style={{ backgroundColor: "green", color: "white" }}>
                         Update Member
                     </Button>
                   </Grid>
                   <Grid item>
                   {isPaymentPending && (
                    <Button
                      type="submit"
                      variant="contained"
                       onClick={() => {
                        navigate("/whatsnext");
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }} 
                      fullWidth
                      style={{ backgroundColor: "#E52029", color: "white" }}
                    >
                      Proceed Payment
                    </Button>
                  )}

                     </Grid>
                     </Grid>
                     </Grid>
        )}</Container>


       {/* Snackbar Alert */}
       <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}  >
       <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
               Member Updated Successfully!
               </Alert>
       </Snackbar>
   </Box>
 );
}